import { CircularProgress, Icon } from '@equinor/eds-core-react'
import { blocked, check, error_outlined, run, time, traffic_light } from '@equinor/eds-icons'
import type { FunctionComponent } from 'react'
import type { ScheduledBatchSummary, ScheduledJobSummary } from '../../store/radix-api'
import { StatusBadgeTemplate, type StatusBadgeTemplateProps } from './status-badge-template'

type JobSchedulerProgressStatus = ScheduledBatchSummary['status'] | ScheduledJobSummary['status']

export const ProgressBadgeTemplates: Record<
  JobSchedulerProgressStatus,
  Pick<StatusBadgeTemplateProps, 'icon' | 'type'>
> = {
  Running: { icon: <Icon data={run} /> },
  Active: { icon: <Icon data={time} /> },
  Succeeded: { icon: <Icon data={check} /> },
  Completed: { icon: <Icon data={check} /> },
  Failed: { type: 'danger', icon: <Icon data={error_outlined} /> },
  Waiting: { icon: <Icon data={traffic_light} /> },
  Stopping: { icon: <CircularProgress /> },
  Stopped: { icon: <Icon data={blocked} /> },
}

export const ProgressStatusBadge: FunctionComponent<{
  status: JobSchedulerProgressStatus
}> = ({ status }) => (
  <StatusBadgeTemplate {...ProgressBadgeTemplates[status]}>
    {status === 'Active' ? 'Starting' : status}
  </StatusBadgeTemplate>
)
